import { defineAsyncComponent } from "vue";
import ErrorLoading from "../htmlComponents/internals/ErrorLoading.vue";
import { removeInvisibleCharacters } from "./utils.js";
export function mountCustomComponent(componentName) {
  if (!componentName) {
    return;
  }
  const component = removeInvisibleCharacters(componentName);
  const components = import.meta.glob("../htmlComponents/**/*.vue");
  const componentPath = `../htmlComponents/${component}/${component}.vue`;
  if (Object.keys(components).includes(componentPath)) {
    return defineAsyncComponent({
      loader: components[componentPath],
      errorComponent: ErrorLoading
    });
  }
  return defineAsyncComponent({
    loader: () => import("../htmlComponents/internals/ErrorNotFound.vue"),
    errorComponent: ErrorLoading
  });
}
